import { Award } from 'lucide-react';
import RecordManager from '../components/RecordManager';

export default function MilitaryRecords() {
  return (
    <RecordManager
      apiPath="military-records"
      testid="military"
      title="Military Records"
      subtitle="Safeguard service history, benefits, and discharge documents for your family."
      icon={Award}
      accent="navy"
      addLabel="Add Record"
      emptyText="No military records yet. Add service details and documents like a DD-214."
      titleField="service_member_name"
      subtitleFields={['branch', 'rank', 'service_start', 'service_end', 'discharge_type']}
      hasDocuments
      fields={[
        { name: 'service_member_name', label: 'Service member name', placeholder: 'e.g., John A. Doe' },
        { name: 'branch', label: 'Branch of service', type: 'select', options: ['Army', 'Navy', 'Air Force', 'Marine Corps', 'Coast Guard', 'Space Force', 'National Guard'] },
        { name: 'rank', label: 'Rank', placeholder: 'e.g., Sergeant First Class' },
        { name: 'service_number', label: 'Service number', placeholder: 'Service / ID number' },
        { name: 'service_start', label: 'Service start', placeholder: 'e.g., 1968' },
        { name: 'service_end', label: 'Service end', placeholder: 'e.g., 1972' },
        { name: 'discharge_type', label: 'Discharge type', type: 'select', options: ['Honorable', 'General', 'Other Than Honorable', 'Medical', 'Other'] },
        { name: 'benefits_info', label: 'Benefits information', type: 'textarea', placeholder: 'VA benefits, pension, burial benefits, contacts…' },
        { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Anything your family should know.' },
      ]}
    />
  );
}
